import React from 'react'

import bg from './../../UI/ingreso/welcome/bg.webp'

interface Props{
    isIntroShowed: boolean
    handleHideIntroScreen: any
} 

interface State{}

class Welcome extends React.Component<Props,State>{
    constructor(props: Props){
        super(props);
        this.state = {}
    }

    render(): React.ReactNode {
        return(
            <div className={this.props.isIntroShowed ? "welcome-main fade-in":"welcome-main fade-out"}>
                <img src={bg}/>
                <div className='welcome-gradient'>
                    <div className='welcome-title'>
                        Bienvenido a nuestro Virtual Ford
                    </div>
                    <div className='welcome-text'>
                        Una experiencia que lo acercará a nuestra línea completa de vehículos. Encuentre el que mejor se adapte a usted.
                    </div>
                    {/*
                        <div className='welcome-tutorial-btn'>
                            Ver tutorial
                        </div>
                    */}
                    <div className='welcome-showroom-btn' id='element-umbra-analytics' data-value={"INGRESO"}  data-type={"INGRESO"} onClick={() => {this.props.handleHideIntroScreen()}}>
                        Entrar
                    </div>
                </div>
            </div>
        )
    }
}

export default Welcome